export default function categoryorganizations(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                categoryorganization: action.categoryorganization,
            }
        default:
            return state;
    }
}
